import { Fragment, useRef, useState,useContext} from "react";
import { Dialog, Transition } from "@headlessui/react";
import { PlusIcon } from "@heroicons/react/outline";
import UploadImage from "../UploadImage";
import AuthContext from '../../AuthContext'
import Centre from '../Dropdowns/Centre'
import Sector from "../Dropdowns/Sector";
import axiosInstance from '../../axios'
import {toast} from 'react-toastify'

export default function AddPurchaseDetails({
  addSaleModalSetting,
  products,
  handlePageUpdate,
  authContext
}) {
  const [sector ,setSector]=useState('')
  const[aff,setAff]=useState('')
  const[smart,setSmart]=useState('')
  const imp=true
  const{userType}=useContext(AuthContext)
  const[type,setType]=useState('hours')
  const [centre,setCentre]=useState('')
  const [status,setStatus]=useState('Accepted')
  const[update,setUpdate]=useState(false)
  const [formData, setFormData] = useState({
    course_name: '',
    course_code: '',
    mess_equivalance: '',
    aff_agency: '',
    cost: '',
    admin_status: '',
    reas_for_rej: '',
    min_quali: '',
    job_role_name: '',
    job_role_cate: '',
    job_role_id: '',
    version:'',
    core_skill_hour:0,
    soft_skill_hour:0,
    ojt_hour:0,
    bridge_hour:0,
    cost_cate:'',


  });
  const [open, setOpen] = useState(true);
  const cancelButtonRef = useRef(null);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const total = parseInt(formData.soft_skill_hour, 10) + parseInt(formData.core_skill_hour, 10) + parseInt(formData.ojt_hour, 10);
  const handleFileChange=(e)=>{
    setAff(e.target.files[0]);
  }
  const handleSmartChange=(e)=>{
    setSmart(e.target.files[0]);
  }
  // Handling Input Change for input fields
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };
const resetForm=()=>{
  setFormData({
    course_name: '',
    course_code: '',
    mess_equivalance: '',
    aff_agency: '',
    cost: '',
    admin_status: '',
    reas_for_rej: '',
    min_quali: '',
    job_role_name: '',
    job_role_cate: '',
    job_role_id: '',
    version:'',
    core_skill_hour:0,
    soft_skill_hour:0,
    ojt_hour:0,
    bridge_hour:0,
    cost_cate:'',
  })
  setAff('')
  setStatus('Accepted')
  setSmart('')
  setSector('')
}
  // POST Data
  const addSale = () => {
    setIsButtonDisabled(true); 
    const form=new FormData()
    form.append('affli_certificate',aff||'')
    form.append('smart_aff_certi',smart||'')
    form.append('course_name', formData.job_role_name);
    form.append('course_code', formData.course_code);
    form.append('mess_equivalance', formData.mess_equivalance);
    form.append('aff_agency', formData.aff_agency);
    form.append('cost', formData.cost);
    form.append('admin_status', status);
    form.append('reas_for_rej', formData.reas_for_rej);
    form.append('min_quali', formData.min_quali);
    form.append('job_role_name', formData.job_role_name);
    form.append('job_role_cate', formData.job_role_cate);
    form.append('job_role_id', formData.job_role_id);
    form.append('version',formData.version);
    form.append('core_skill_hour', formData.core_skill_hour);
    form.append('soft_skill_hour', formData.soft_skill_hour);
    form.append('ojt_hour', formData.ojt_hour);
    form.append('bridge_hour', formData.bridge_hour);
    form.append('cost_cate', formData.cost_cate);
    form.append('sector_id',sector);
    form.append('attendance_type',type)
    axiosInstance.post(`courses/insert`,form)
      .then((result) => {
        toast.success("Course Added Successfully");
        handlePageUpdate();
        resetForm()
      })
      .catch((err) => {
        if(err.response||err.response.data||err.response.data.messag){
         if(err.response.data.message.includes('Duplicate entry')){
           toast.error("Course Code already exists");
         }
        }
      })
      .finally(() => {
        setIsButtonDisabled(false); // Re-enable the button after toast is displayed
      })
      
      
  };
  return (
    // Modal
    <Transition.Root show={open} as={Fragment}>
    <Dialog
      as="div"
      className="relative z-10"
      initialFocus={cancelButtonRef}
      onClose={setOpen}
    >
      <Transition.Child
        as={Fragment}
        enter="ease-out duration-300"
        enterFrom="opacity-0"
        enterTo="opacity-100"
        leave="ease-in duration-200"
        leaveFrom="opacity-100"
        leaveTo="opacity-0"
      >
        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
      </Transition.Child>

      <div className="fixed inset-0 z-10 overflow-y-auto">
        <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enterTo="opacity-100 translate-y-0 sm:scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          >
            <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-4xl">
              <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                <div className="sm:flex sm:items-start">
                  <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-blue-100 sm:mx-0 sm:h-10 sm:w-10">
                    <PlusIcon
                      className="h-6 w-6 text-blue-400"
                      aria-hidden="true"
                    />
                  </div>
                  <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left ">
                    <Dialog.Title
                      as="h3"
                      className="text-lg font-semibold leading-6 text-gray-900 "
                    >
                        Add New Course
                      </Dialog.Title>
                      <form action="#">
                        <div className="grid gap-4 mb-4 sm:grid-cols-4">
                        
      <div>
      <Sector value={sector} handleInputChange={(e)=>{setSector(e.target.value);setUpdate(!update)}} imp={imp} centre_id={centre}/>
      </div>
      <div >
        <label  className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
          Course Code </label>
        <input
          type="text"
          name="course_code"
          value={formData.course_code}
          
          onChange={handleChange}
                                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"

          
                                  aria-autocomplete="true" 

        />
      </div>
     
      <div>
                            <label htmlFor="aff"
                            className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >Affiliation Certificate</label>
                            <label
        htmlFor="aff"
        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"      >
        <svg
          className="w-6 h-5 inline-block mr-2"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3 16V21H21V16H3ZM5 18H19V16H5V18ZM3 6H21V14H3V6ZM5 10H19V8H5V10Z"
            fill="currentColor"
          />
        </svg>
        <span className="inline-block">
          {" "}
          {aff?.name && aff.name.length > 8
            ? aff.name.substring(0, 8) + "..."
            : aff?.name || "Choose file"}
        </span>
      </label>
      <input
        type="file"
        id="aff"
        className="hidden"
        accept=".pdf"
        
        aria-autocomplete="true" 
        onChange={handleFileChange}
      />
                          </div>
      <div>
        <label  className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
          MES_SSC Equivalence </label>
        <input
          type="text"
          name="mess_equivalance"
          value={formData.mess_equivalance}
          onChange={handleChange}
                                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"

          
                                  aria-autocomplete="true" 
        />  
      </div>
      <div >
        <label  className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
          Affiliation Agency </label>
        <input
          type="text"
          name="aff_agency"
          value={formData.aff_agency}
          onChange={handleChange}
                                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"

          
                                  aria-autocomplete="true" 
        />
      </div>
  
      <div>
                            <label htmlFor="smart"
                            className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >SMART Aff. Equivalence</label>
                            <label
        htmlFor="smart"
        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"      >
        <svg
          className="w-6 h-5 inline-block mr-2"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3 16V21H21V16H3ZM5 18H19V16H5V18ZM3 6H21V14H3V6ZM5 10H19V8H5V10Z"
            fill="currentColor"
          />
        </svg>
        <span className="inline-block">
          {" "}
          {smart?.name && smart.name.length > 8
            ? smart.name.substring(0, 8) + "..."
            : smart?.name || "Choose file"}
        </span>
      </label>
      <input
        type="file"
        id="smart"
        className="hidden"
        accept=".pdf"
        required
        onChange={handleSmartChange}
      />
                          </div>
                          
      <div >
        <label  className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
          Minimum Qualification </label>
        <input
          type="text"
          name="min_quali"
          value={formData.min_quali}
          onChange={handleChange}
                                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"

          
                                  aria-autocomplete="true" 
        />
      </div>
      <div >
        <label  className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
          Job Role ID </label>
        <input
          type="number"
          name="job_role_id"
          value={formData.job_role_id}
          onChange={handleChange}
          
          aria-autocomplete="true" 
                                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"

        />
      </div>  
      <div >
        <label  className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
          Job Role Name </label>
        <input
          type="text"
          name="job_role_name"
          value={formData.job_role_name}
          onChange={handleChange}
                                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"

          
                                  aria-autocomplete="true" 
        />
      </div>
      <div >
        <label  className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
          Job Role Category </label>
        <input
          type="text"
          name="job_role_cate"
          value={formData.job_role_cate}
          onChange={handleChange}
                                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"

          
                                  aria-autocomplete="true" 
        />
      </div>
      <div >
        <label  className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
          Version </label>
        <input
          type="text"
          name="version"
          value={formData.version}
          onChange={handleChange}
                                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"

          
                                  aria-autocomplete="true" 
        />
      </div>
      
  <div>
                            <label htmlFor="type"
                              className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                Attendance Type </label>
                                <select
                id="type"
                value={type}
                onChange={e=>setType(e.target.value)}
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"   
                >
                <option value='' disabled>------Select-----</option>
                <option value="days">Days</option>
                <option value="hours">Hours</option>
               


            </select>
                            </div>
                            <div >
        <label  className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
          Soft Skills Duration </label>
        <input
          type="number"
          name="soft_skill_hour"
          value={formData.soft_skill_hour}
          onChange={handleChange}
          
          aria-autocomplete="true" 
                                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"

        />
      </div>
      <div >
        <label  className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
          Core Skills Duration </label>
        <input
          type="number"
          name="core_skill_hour"
          value={formData.core_skill_hour}
          onChange={handleChange}
          
          aria-autocomplete="true" 
                                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"

        />
      </div>
      <div >
        <label  className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">OJT Duration
        
        </label>
        <input
          type="number"
          name="ojt_hour"
          value={formData.ojt_hour}
          onChange={handleChange}
          
          aria-autocomplete="true" 
                                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"

        />
      </div>
      <div >
        <label  className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Total Duration </label>
        <input
          type="number"
          name="total"
          value={total}          
          aria-autocomplete="true" 
                                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"

        />
      </div>
     

      <div >
        <label  className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
          Course Cost </label>
        <input
          type="text"
          name="cost"
          value={formData.cost}
          onChange={handleChange}
          
          aria-autocomplete="true" 
                                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"

        />
      </div>
      <div >
        <label  className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
          Cost Category </label>
        <input
          type="text"
          name="cost_cate"
          value={formData.cost_cate}
          onChange={handleChange}
          
          aria-autocomplete="true" 
                                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"

        />
      </div>
                        </div>
                        <div className="flex items-center space-x-4">
                          {/* <button
                            type="submit"
                            className="text-white bg-primary-700 hover:bg-primary-800 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800"
                          >
                            Update product
                          </button> */}
                          {/* <button
                            type="button"
                            className="text-red-600 inline-flex items-center hover:text-white border border-red-600 hover:bg-red-600 focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:border-red-500 dark:text-red-500 dark:hover:text-white dark:hover:bg-red-600 dark:focus:ring-red-900"
                          >
                            <svg
                              className="mr-1 -ml-1 w-5 h-5"
                              fill="currentColor"
                              viewBox="0 0 20 20"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                fill-rule="evenodd"
                                d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
                                clip-rule="evenodd"
                              ></path>
                            </svg>
                            Delete
                          </button> */}
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
                <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                <button
                className={`inline-flex w-full justify-center rounded-md px-3 py-2 text-sm font-semibold text-white shadow-sm sm:ml-3 sm:w-auto 
                ${isButtonDisabled ? 'bg-gray-400 cursor-not-allowed' : 'bg-blue-600 hover:bg-blue-500'}`}
                onClick={addSale}
                disabled={isButtonDisabled}
                >
                          {isButtonDisabled ? 'Adding...' : 'Add Course'}
                          </button>
                  <button
                    type="button"
                    className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                    onClick={() => addSaleModalSetting()}
                    ref={cancelButtonRef}
                  >
                    Cancel
                  </button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}
